import { Card } from "antd";
import { LinkOutlined } from "@ant-design/icons";
import type { SidebarContent } from "../../config/modulePageConfig";
import styles from "./RightSidebar.module.css";

const SidebarCards = ({
  question,
  periodYears,
  dimensions,
  fontSources,
}: SidebarContent) => {
  return (
    <>
      <Card className={styles.card}>
        <div className={styles.cardHeader}>
          <h4 className={styles.cardTitle}>PREGUNTA</h4>
        </div>
        <div className={styles.cardContent}>
          <p>{question}</p>
        </div>
      </Card>

      <Card className={`${styles.card} ${styles.periodCard}`}>
        <div className={styles.cardHeader}>
          <h4 className={styles.cardTitle}>PERÍODE TEMPORAL</h4>
        </div>
        <div className={styles.cardContent}>
          <div className={styles.periodInput}>
            <span>{periodYears}</span>
          </div>
        </div>
      </Card>

      <Card className={`${styles.card} ${styles.dimensionsCard}`}>
        <div className={styles.cardHeader}>
          <h4 className={styles.cardTitle}>DIMENSIONS ANALITZADES</h4>
        </div>
        <div className={styles.cardContent}>
          <div className={styles.tagsContainer}>
            {dimensions.map((label, i) => (
              <span key={i} className={styles.tag}>
                {label}
              </span>
            ))}
          </div>
        </div>
      </Card>

      <Card className={styles.card}>
        <div className={styles.cardHeader}>
          <h4 className={styles.cardTitle}>FONT</h4>
        </div>
        <div className={styles.cardContent}>
          <div className={styles.sourceLinks}>
            {fontSources.map((label, i) => (
              <span key={i} className={styles.sourceLink}>
                <LinkOutlined /> {label}
              </span>
            ))}
          </div>
        </div>
      </Card>
    </>
  );
};

export default SidebarCards;
